export default __webpack_public_path__ + "static/media/CareEvent4-min.6e186910.png";